import { render } from "./SideBarLCA.vue?vue&type=template&id=64f8e754"
import script from "./SideBarLCA.vue?vue&type=script&lang=js"
export * from "./SideBarLCA.vue?vue&type=script&lang=js"

import "./SideBarLCA.vue?vue&type=style&index=0&id=64f8e754&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__